import type { NerPosResponse } from "../types/nerPos"

type Props = {
  result: NerPosResponse
}

export default function TableResult({ result }: Props) {
  const tokens = result.text

  const columns = Object.entries(result.prediction)
    .filter(([, values]) => values !== null)
    .map(([key, values]) => [key, values ?? []] as const
  )

  return (
    <div className="mt-6">

      {result.text_truncated && (
        <p className="font-medium mb-2">
          Because the input text was too long, some of it was truncated.
        </p>
      )}

      <table className="w-full border">
        <thead>
          <tr>
            <th className="border p-2 text-left">Token</th>

            {columns.map(([key]) => (
              <th key={key} className="border p-2 text-left uppercase">
                {key}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {tokens.map((token, i) => (
            <tr key={i}>
              <td className="border p-2">{token}</td>

              {columns.map(([key, values]) => (
                <td key={key} className="border p-2">
                  {values[i] ?? "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}